module.exports = __webpack_public_path__ + "static/img/jeans_left_red.49ff4752.png";